import {
  EventHiddenReason,
  EventType,
  type EventFragment,
} from "~/__generated__/graphql/graphql";

export function isTicketSalesAwaitingApproval(plan: EventFragment): boolean {
  return (
    plan.type === EventType.Ticketed &&
    plan.hiddenReason === EventHiddenReason.WaitingTicketSalesApproval
  );
}

export function isTicketCheckoutAvailable(plan: EventFragment): boolean {
  return plan.isPublished && !isTicketSalesAwaitingApproval(plan);
}
